<template>
    <div class="bg re_sizing">
        <!-- <div class="title re_relative re_flex_center re_font_18">
            <van-icon @click="goBack(1)" class="icon" name="arrow-left" size="22" />
            <span>单身泡泡协议</span>
        </div> -->
        <div class="title re_font_18">
            <van-icon @click="goBack(1)" class="icon" name="arrow-left" size="22" />
            <div>单身泡泡协议</div>
        </div>
        <div class="blank"></div>
        <div class="agreement-container">
            <h2>一、单身泡泡：</h2>
            <ol>
                <li>单身泡泡是专门为缴纳诚意金的单身用户开启的版块，为单身用户提供社交平台，快速脱单，让陌生社交零距离。</li>
            </ol>

            <h2>二、适用对象：</h2>
            <ol>
                <li>缴纳诚意金的单身用户。</li>
            </ol>

            <h2>三、使用规则：</h2>
            <ol>
                <li>需要完成实名认证并缴纳诚意金，确保平台社交安全。</li>
                <li>平台默认每月赠送100次发布泡泡的机会，超出次数将按照1元/条收取。</li>
                <li>每位用户都可以发布单身泡泡，上传音频、视频、照片、个人介绍、个人性格特征、开启泡泡条件。</li>
                <li>泡泡被他人开启后，会收到预设的礼物打赏，最终会转换为可提现的金额，进入"我的-服务-待提现"中操作。</li>
                <li>仅支持异性与互拆泡泡。</li>
            </ol>

            <h2>四、注意事项</h2>
            <ol>
                <li>您在发布泡泡信息的过程中须遵守法律、法规、规章、政策和公序良俗，内容健康，且不侵犯他人合法权益，不违反平台的任何协议或者规则。平台将对您发布的信息进行审核，若包含以下内容将无法通过平台审核或被平台删除:违反国家法律法规禁止性规定的信息;涉及政治、封建迷信、淫秽色情、赌博、暴力、恐怖、教唆犯罪的信息;侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的信息;推广微信群、QQ群等社交软件群的信息、广告信息、虚假或有误导性的信息;活动活动本身存在明显的危险性;以及其他违背社会公共利益或公共道德或依据平台规则不适合在平台上发布的信息。
                </li>
                <li>请您注意，本活动功能仅为用户社交提供平台技术支持，活动内容均由发起者自行发布并与参与者协商确定，用户之间因活动变动、撤销活动或线下活动引起的纠纷须由用户自行解决并承担相应后果。</li>
                <li>用户直接或通过各类方式（如站外API引用、下载等）间接使用单身泡泡服务和数据的行为，都将被视作已无条件接受本声明所涉全部内容；若用户对本声明的任何条款有异议，请停止使用单身泡泡及相应小程序所提供的全部服务。
                </li>
                <li>用户以各种方式使用单身泡泡服务和数据（包括但不限于发表、宣传介绍、转载、浏览、下载及利用单身泡泡用户发布内容）的过程中，不得以任何方式利用单身泡泡直接或间接从事违反中国法律（包括但不限于入侵非授权的计算机系统，查阅、下载、盗版、篡改任何非授权数据，传播恶意软件）、以及社会公德的行为，我们不为任何个人或组织的违法行为负责，亦不承担任何法律责任。必要时，我们将为公安机关提供协助。
                    <p>用户应当恪守下述承诺：</p>
                    <ol>
                        <li>发布、转载或提供的内容符合中国法律、社会公德；</li>
                        <li>不得干扰、损害和侵单身泡泡的各种合法权利与利益；</li>
                        <li>遵守单身泡泡以及与之相关的网络服务的协议、指导原则、管理细则等；</li>
                        <li>我们有权对违反上述承诺的内容予以删除。</li>
                    </ol>
                </li>
            </ol>
        </div>
    </div>
</template>

<script setup>
// import { getDrawConfig } from './api.js'
import { ref, onMounted } from 'vue';
const ruleInfo = ref('{withdrawalRules}');
const goBack = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        try {
            appJsImp.finish()
        } catch (error) {
            android.finish()
        }
    }
    if (isiOS) {
        window.webkit.messageHandlers.AppModel.postMessage('finish')
    }
}
</script>

<style lang="less" scoped>
@import url(./rule.less);
h2 {
    font-size: 1.2rem;
}
li {
    margin-bottom: 10px;
}
.agreement-container {
    text-align: left;
    max-width: 800px;
    margin: 0 auto;
    background-color: #fff;
    padding: 30px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
</style>